import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import LoggedUser from './LoggedUser';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import Usuario from '../../Utils/Usuario';
import Geral from '../../Utils/Geral';
import { Permissions } from '../../Utils/Permissions';
import './Header.scss';
import ErrorModal from '../ErrorModal/ErrorModal';

class Header extends Component {

    constructor() {
        super();

        this.configurations = new Configurations();

        this.logout = this.logout.bind(this);
        this.toggleDropdownAtendimento = this.toggleDropdownAtendimento.bind(this);
        this.selecionaAtendimentoDropdown = this.selecionaAtendimentoDropdown.bind(this);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.irParaHome = this.irParaHome.bind(this);

        this.state = {
            collapseMenu: false,
            viewMessages: false,
            isLoading: false,
            options: [],
            // atendimentosMenu: [],
            // isOpenDropdownAtendimento: false,
            hasError: false,
            errorMessage: '',
        };
    }

    componentDidMount() {
        const _arrPerm = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat();
        let _busca;
        // let _atendimento;
        if (["admin"].some(r => _paginas.indexOf(r) >= 0)) {
            _busca = true;
            // _atendimento = true;
        } else {
            _busca = ["pedidos"].some(r => _paginas.indexOf(r) >= 0);
            // _atendimento = ["atendimento"].some(r => _paginas.indexOf(r) >= 0);

        }
        this.setState({
            buscaHeader: _busca,
            // flagAtendimento: _atendimento 
        })
    }

    logout() {
        localStorage.clear();
        // Usuario.setLoggedUser = undefined;
        this.props.logout();
        window.location.href = "/";
    }

    paymentBadgeType(status) {
        switch (status) {
            case "pago":
                return "success";
            case "vencido":
                return "secondary";
            case "negado":
                return "danger";
            case "Baixa Manual":
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    tipoBadgeAtendimento(status) {
        switch (status) {
            case 2:
                return "warning";
            case 3:
                return "info";
            case 4:
                return "success";
            default: //
                return "primary";
        }
    }

    toggleDropdownAtendimento() {
        this.setState({ isOpenDropdownAtendimento: !this.state.isOpenDropdownAtendimento })
    }

    selecionaAtendimentoDropdown(_idAtend) {
        this.toggleMenuAcessoRapido(true, _idAtend, null, "atendimento");
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    irParaHome() {
        if (this.props.isOpenMenuMobile) {
            this.props.toggleMenuMobile();
        }
        this.props.history.push("/");
    }



    render() {
        return (
            <header className="ebs-header">
                <div className="row align-items-center">
                    <div className="col-9 col-md-2 text-center">
                        <img onClick={this.irParaHome} src={this.props.logo} alt="Fukyo Editora Brasil Seikyo" className="ebs-logo img-fluid cursor-pointer" />

                    </div>
                    {/* <div className={`col-${this.state.flagAtendimento ? '4' : '8'} d-none d-md-block px-0`}> */}
                    <div className={`col-8 d-none d-md-block px-0`}>
                        {this.state.buscaHeader && (
                            <form className="form-header" action="" method="POST">
                                <AsyncTypeahead
                                    id="mainSearch"
                                    isLoading={this.state.isLoading}
                                    className="ebs-typeahead w-100"
                                    onChange={(s) => {
                                        if (s && s.length > 0) {
                                            switch (s[0].type) {
                                                case 0:
                                                    this.props.history.push(`/pedidos/detalhes/${s[0].idPedido}`);
                                                    break;
                                                default:
                                                    if (!!s[0].idUsuario) this.props.history.push(`/assinante/${s[0].idUsuario}`);
                                            }
                                        }
                                    }}
                                    labelKey={(option) => {
                                        if (option) {
                                            switch (option.type) {
                                                case 0:
                                                    return `P${option.idPedido.toString()}`;
                                                case 1:
                                                    return `M${option.codMembro.toString()}`;
                                                case 3:
                                                    return `C${option.cpf.toString()}`;
                                                default:
                                                    return option.nome;
                                            }
                                        } else {
                                            return option;
                                        }
                                    }
                                    }
                                    renderMenuItemChildren={(option, props, idx) => (
                                        (option.idPedido) ? (
                                            <div className="ebs-typeahead-order-item">
                                                &nbsp;Pedido&nbsp;
                                                <Highlighter search={props.text.substr(1, props.text.length)}>
                                                    {option.idPedido ? option.idPedido.toString() : ''}
                                                </Highlighter>
                                                &nbsp;/ {option.nomeSolicitante}&nbsp;<small>({option.codMembro})</small>
                                                &nbsp;/&nbsp;<span className={`badge badge-${Geral.paymentBadgeType(option.statusPagamento)}`}>{option.statusPagamento}</span>
                                            </div>) : (
                                            <div className="d-flex align-items-center border-bottom">
                                                <span className="badge badge-info">{option.divisao ? option.divisao : 'US'}</span>
                                                &nbsp;
                                                    {option.nome}
                                                &nbsp;<small>(
                                                    <Highlighter search={props.text.substr(1, props.text.length)}>
                                                        {option.codMembro ? option.codMembro.toString() : 'Não membro'}
                                                    </Highlighter>)</small>
                                                &nbsp; {option.codMembro ? `- ${option.coordenadoria}` : ''}
                                            </div>
                                        )
                                    )}
                                    delay={400}
                                    emptyLabel="Nenhum resultado encontrado"
                                    searchText="Procurando..."
                                    promptText="Digite para procurar..."
                                    minLength={2}
                                    placeholder="Insira o número do pedido ou código de membro..."
                                    onSearch={query => {
                                        this.setState({ isLoading: true });
                                        axios.get(this.configurations.apiBasePath + `/busca?query=${query}`)
                                            .then(resp => {
                                                if (resp.data && (resp.data.orders || resp.data.users)) {
                                                    this.setState({
                                                        isLoading: false,
                                                        options: resp.data.orders.length > 0 ? resp.data.orders : resp.data.users
                                                    });
                                                }
                                            });
                                    }}
                                    options={this.state.options}
                                    filterBy={() => true}
                                />
                            </form>
                        )}
                    </div>
                    <div className="col-2 d-none d-md-block">
                        <div className="row no-gutters align-items-center">
                            <div className="col-8 text-right">
                                <button onClick={this.props.logout} className="btn btn-outline-secondary">logout</button>
                            </div>
                            <div className="col-4 text-center">
                                <LoggedUser />
                            </div>
                        </div>
                    </div>
                    <div className="col-3 d-md-none">
                        <i onClick={this.props.toggleMenuMobile} className={`icone-menu-mobile fas fa-bars text-${this.props.isOpenMenuMobile ? "primary" : "secondary"}`}></i>
                    </div>
                </div>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={false}
                />
            </header>
        )
        // return (
        //     <Consumer>
        //         {({ listaAtendimentosMenu, openMenuAcessoRapido, toggleMenuAcessoRapido, idAtendimentoAtual, flagAlteracaoAtendimento }) => {
        //             this.openMenuAcessoRapido = openMenuAcessoRapido;
        //             this.toggleMenuAcessoRapido = toggleMenuAcessoRapido;
        //             this.idAtendimentoAtual = idAtendimentoAtual;

        //         }}
        //     </Consumer>
        // )
    }
}

export default withRouter(Header);